/** Do not edit this file, it is automatically generated **/
import React from "react";
import styled from "styled-components";

import Icon, {
  IconProps,
} from "@examspark/common-ui/dist/components/icons/Icon";

const IconLeafComponent: React.FC<React.PropsWithChildren<IconProps>> = (
  props,
) => {
  return (
    <Icon {...props} viewBox="0 0 512 512">
      <g>
        <g>
          <path
            d="M511.164,16.896c-2.036-6.195-7.457-10.603-13.938-11.334c-0.448-0.048-37.687-4.242-91.604-4.244
			c-35.22,0.001-77.556,1.787-121.496,7.755c-32.957,4.481-66.822,11.309-99.312,21.607c-24.365,7.727-47.965,17.408-69.8,29.602
			c-16.372,9.147-31.753,19.714-45.648,31.951c-20.838,18.338-38.327,40.508-50.473,66.874C6.729,185.462-0.014,215.895,0,250.332
			c0,23.358,3.072,48.571,9.542,75.791c5.981,25.161,14.869,52.049,26.951,80.836c-12.542,25.958-23.479,53.334-32.396,82.168
			c-2.715,8.776,2.199,18.093,10.977,20.806c8.776,2.715,18.093-2.199,20.808-10.977c7.417-23.977,16.322-46.897,26.452-68.807
			c25.191,12.565,50.755,22.488,76.183,29.586c30.664,8.558,61.135,13.028,90.511,13.03c27.79,0,54.616-4.009,79.563-12.425
			c18.705-6.309,36.346-15.107,52.43-26.494c24.136-17.068,44.698-39.986,60.185-68.525c15.507-28.545,25.977-62.636,30.524-102.241
			c11.672-101.712,26.554-160.366,38.069-192.823c5.75-16.23,10.646-25.901,13.774-31.155c1.564-2.628,2.683-4.153,3.237-4.858
			c0.139-0.176,0.243-0.302,0.309-0.379l0.086-0.1l-0.003-0.003C511.574,29.33,513.122,22.852,511.164,16.896z M56.991,368.159
			c-6.382-17.532-11.368-34.097-15.083-49.727c-5.949-25.034-8.639-47.665-8.639-68.1c0.004-23.821,3.636-44.653,10.093-63.09
			c5.658-16.133,13.488-30.462,23.172-43.365c8.475-11.285,18.381-21.472,29.517-30.685c19.476-16.12,42.749-29.238,68.26-39.735
			c38.254-15.761,81.476-25.571,123.679-31.333c42.205-5.774,83.38-7.539,117.633-7.537c12.942,0,24.893,0.251,35.548,0.628
			c-43.86,20.701-103.601,52.722-165.732,97.746c0.079-0.916,0.164-1.842,0.261-2.782c1.026-10.045,3.086-21.461,6.867-33.025
			c2.852-8.733-1.915-18.125-10.647-20.977c-8.733-2.852-18.125,1.915-20.977,10.647c-4.667,14.296-7.112,28.007-8.338,39.967
			c-0.816,7.975-1.088,15.175-1.088,21.268c0,3.045,0.068,5.814,0.171,8.266c0.032,0.762,0.068,1.485,0.107,2.184
			c-7.981,6.348-15.963,12.905-23.914,19.69c-29.38,25.078-58.352,53.186-85.478,84.478c-0.169-3.442-0.261-6.859-0.261-10.241
			c0-7.81,0.43-15.451,1.207-22.878c2.253-21.576,7.441-41.35,13.387-58.087c3.074-8.658-1.452-18.168-10.108-21.242
			c-8.658-3.074-18.168,1.452-21.242,10.108c-6.658,18.756-12.538,41.036-15.125,65.761c-0.889,8.508-1.387,17.303-1.387,26.337
			c-0.001,14.78,1.347,30.207,4.477,46.014c-3.296,4.341-6.567,8.715-9.781,13.165C80.605,329.56,68.345,348.405,56.991,368.159z
			 M448.55,90.972c-10.173,37.076-20.961,90.727-29.875,168.314c-3.68,32.025-11.499,59.169-22.451,81.854
			c-8.22,17.019-18.198,31.547-29.636,43.851c-17.164,18.441-37.633,31.949-60.811,40.989
			c-23.169,9.025-49.076,13.519-76.752,13.519c-25.991,0.002-53.514-3.972-81.566-11.805c-23.264-6.493-46.886-15.645-70.291-27.319
			c13.07-24.436,27.652-47.517,43.37-69.284c2.354-3.26,4.742-6.481,7.146-9.682c3.929,1.398,9.963,3.423,17.737,5.66
			c14.089,4.052,33.857,8.796,57.056,11.669c12.724,1.574,26.483,2.582,40.91,2.583c11.876,0,24.204-0.684,36.772-2.311
			c9.111-1.18,15.541-9.522,14.361-18.633c-1.18-9.111-9.522-15.541-18.633-14.361c-10.997,1.424-21.904,2.036-32.502,2.036
			c-12.872,0-25.284-0.903-36.826-2.331c-21.043-2.601-39.183-6.95-51.941-10.623c-1.742-0.501-3.373-0.988-4.908-1.457
			c34.61-41.348,72.938-77.287,111.501-108.08c1.293,0.539,2.696,1.103,4.217,1.687c8.778,3.366,21.301,7.326,36.854,9.966
			c10.368,1.759,22.082,2.93,34.903,2.93c6.411,0,13.097-0.293,20.026-0.95c9.146-0.867,15.857-8.985,14.99-18.131
			c-0.867-9.146-8.985-15.857-18.131-14.99c-5.851,0.554-11.487,0.802-16.884,0.802c-10.796,0-20.645-0.986-29.337-2.461
			c-5.372-0.912-10.295-2.012-14.727-3.177c3.34-2.433,6.677-4.836,10.004-7.192c57.594-40.805,112.776-70.189,153.374-89.283
			C453.924,72.42,451.261,81.104,448.55,90.972z"
          />
        </g>
      </g>
    </Icon>
  );
};

const IconLeaf = styled(IconLeafComponent)``;

export default IconLeaf;
